import { z } from 'zod'

export const PaylinkNotificationSchema = z.object({
  type: z.literal('paylink'),
  url: z.string(),
})

export const PurchaseConfirmationNotificationSchema = z.object({
  type: z.literal('purchase-confirmation'),
  order: z.object({
    orderId: z.string(),
    orderTotal: z.string(),
    orderDate: z.string(),
  }),
})

export const NotificationSchema = z.discriminatedUnion('type', [
  PaylinkNotificationSchema,
  PurchaseConfirmationNotificationSchema,
])

export type PaylinkNotification = z.infer<typeof PaylinkNotificationSchema>
export type PurchaseConfirmationNotification = z.infer<
  typeof PurchaseConfirmationNotificationSchema
>
export type Notification = z.infer<typeof NotificationSchema>

